import React from "react";
import { motion } from "framer-motion";

/**
 * Component to display section summaries (editable text boxes)
 * Replaces NarrativeSection with editable summary text
 */
const OriginalResponsesDisplay = ({
  sectionType,
  responseData,
  questionnaireData,
  textColor = "rgba(255, 255, 255, 0.9)",
  accentColor = "var(--primary-color)",
}) => {
  if (!responseData) {
    return (
      <div className="text-white/60 text-center py-4">
        No responses available
      </div>
    );
  }

  // Get the summary for this section from metadata
  const summaries = responseData.metadata?.sectionSummaries || {};
  const summary = summaries[sectionType] || "";

  if (!summary || summary.trim() === "") {
    return (
      <div className="text-white/60 text-center py-4">
        No summary available for this section
      </div>
    );
  }

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      className="space-y-6"
      style={{ color: textColor }}
    >
      <div
        className="whitespace-pre-wrap leading-relaxed"
        style={{ 
          color: textColor,
          fontSize: "1.2rem",
          lineHeight: "1.8",
          fontWeight: "500",
        }}
      >
        {summary}
      </div>
    </motion.div>
  );
};

export default OriginalResponsesDisplay;

